class HomeGlobalNav {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // クローンしたい要素を選択（例：IDが'myElement'の要素）
    var elementToClone = document.querySelector('.js-pc-nav');

    // 要素をクローン（子要素も含む）
    var clonedElement = elementToClone.cloneNode(true);

    // クローンした要素に'is-clone'クラスを追加
    clonedElement.classList.add('is-clone');

    // クローンした要素の中の'.js-pc-nav-toggle'要素を選択
    var toggleElement = clonedElement.querySelector('.js-pc-nav-toggle');

    // クリックイベントリスナーを追加
    toggleElement.addEventListener('click', function() {
        clonedElement.classList.toggle('is-active');
      });
    //　スクロールしたら閉じる
      window.addEventListener("scroll", () => {
      clonedElement.classList.remove('is-active');
    })

    // フッター要素を選択（例：タグ名が'footer'の最初の要素）
    var footer = document.getElementsByTagName('footer')[0];

    // クローンした要素をフッターの前に挿入
    footer.parentNode.insertBefore(clonedElement, footer);

    // ScrollTriggerを設定
    ScrollTrigger.create({
      trigger: '.js-home-mv',
      start: 'bottom top', // '.js-home-mv'が画面の下部を通過した時,
      onLeaveBack: () => clonedElement.classList.remove('is-show','is-active'), // 画面から見えなくなった時
      onEnter: () => clonedElement.classList.add('is-show'),   // 画面に再度表示された時
    });
    ScrollTrigger.create({
      trigger: '.top-footer',
      start: 'top', // '.js-home-mv'が画面の下部を通過した時,
      onLeaveBack:  () => clonedElement.classList.add('is-show'), // 画面から見えなくなった時
      onEnter:() => clonedElement.classList.remove('is-show','is-active'),   // 画面に再度表示された時
      // markers:true
    });



  }
}
